import React from 'react';

import type { Props } from './types';

import NavigationDesktop from 'ui/snippets/navigation/horizontal/NavigationDesktop';

import * as Layout from './components';
const LayoutSearchResults = ({ children }: Props) => {

  return (
    <Layout.Container>
      <Layout.TopRow/>
      <NavigationDesktop/>
      <Layout.NavBar/>
      { children }
    </Layout.Container>
  );
};

export default LayoutSearchResults;
